<ut-button
  variant="ghost"
  iconOnly
  iconLeft="x"
  aria-label="Close"
  (clicked)="close()"
></ut-button>
@if (htmlDocumentTranslation) {
  <div ut-dialog-content>
    @if (htmlDocument) {
      <div class="header-2">
        {{ htmlDocumentTranslation.title }}
      </div>
      <div [innerHTML]="htmlDocumentTranslation.contents"></div>
    }
  </div>
}
